import { BrandName } from '../../../windows-types';

export const CERTIFICATE_BLOCK_MAP: Record<BrandName, Record<string, string>> = {
  deceuninck: {
    href:
      'https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/windows/Deceuninck_partner_certificate_Leroy_Merlin.pdf',
    title: 'Сертификат DECEUNINCK',
  },
  rehau: {
    href:
      'https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/windows/Rehau_partner_certificate_Leroy_Merlin.pdf',
    title: 'Сертификат REHAU',
  },
  veka: {
    href:
      'https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/windows/Veka_partner_certificate_Leroy_Merlin.pdf',
    title: 'Сертификат VEKA',
  },
};
